import React, { useState } from 'react';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import * as R from 'ramda';

import { colors, styled } from 'core/styles';

import { InfoIcon } from '../icons';

export function InfoTooltip(props: Omit<TooltipProps, 'children'>) {
  const [open, setOpen] = useState(false);
  const { open: openProp, onOpen: onOpenProp, onClose: onCloseProp, ...rest } = props;

  const handleOpen: TooltipProps['onOpen'] = event => {
    if (openProp !== undefined) {
      onOpenProp?.(event);
    } else {
      setOpen(true);
    }
  };

  const handleClose: TooltipProps['onClose'] = event => {
    if (openProp !== undefined) {
      onCloseProp?.(event);
    } else {
      setOpen(false);
    }
  };

  const handleClick: TooltipProps['onClose'] = event => {
    event.stopPropagation();
  };

  return (
    <Tooltip
      open={openProp ?? open}
      onOpen={handleOpen}
      onClose={handleClose}
      onClick={handleClick}
      {...R.mergeDeepLeft(rest, {
        enterTouchDelay: 0,
        leaveTouchDelay: 4000,
        componentsProps: {
          tooltip: { sx: { maxWidth: '250px' }, onClick: handleClick },
        },
      })}
    >
      <TooltipIcon active={openProp ?? open}>
        <InfoIcon fontSize="inherit" />
      </TooltipIcon>
    </Tooltip>
  );
}

const TooltipIcon = styled('span', { shouldForwardProp: prop => prop !== 'active' })<{
  active: boolean;
}>(({ theme, active }) => ({
  display: 'inline-flex',
  fontSize: 'inherit',
  verticalAlign: 'middle',
  color: active ? colors.black : colors.blackOpacity[50],
  transition: theme.transitions.create('color'),
  cursor: 'pointer',
}));
